/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

import { createSelector } from 'reselect';
import { selectFormInitialValues, getCurrentFormValueByFieldName } from '../../form/selectors';
import { getSelectedEntity, getCurrentEntityStore } from '../selectors';
import { Map } from 'immutable';

export const getDispatchMappings = (state) => state.getIn(['Entities', 'dispatchMappings', 'data']);

export const selectDispatchMappingsFormInitialValues = state => {
  if (getSelectedEntity(state) === undefined) {
    return new Map({ active: true, interactionField: 'customer', channelType: 'any', version: 'null' });
  }
  return !selectFormInitialValues(state).get('version')
    ? selectFormInitialValues(state).set('version', 'null')
    : selectFormInitialValues(state);
};

const getCurrentInteractionFieldValue = state => getCurrentFormValueByFieldName(state, 'interactionField');

const getCurrentChannelTypeValue = state => getCurrentFormValueByFieldName(state, 'channelType');

const getCurrentValueFieldValue = state => getCurrentFormValueByFieldName(state, 'value');

export const getMappingValueMessage = state =>
  `Enter${
    ['voice', 'sms', 'messaging'].includes(getCurrentChannelTypeValue(state)) &&
    getCurrentInteractionFieldValue(state) === 'contact-point'
      ? ' an e.164 formatted number or SIP address'
      : getCurrentChannelTypeValue(state) === 'email' &&
        getCurrentInteractionFieldValue(state) === 'contact-point'
        ? ' an email address'
        : 'a mapping value'
  }`;

/**
 * Returns if current open form has an invalid
 * mapping value, only if channelType is voice|sms
 * and interactionField is customer|contact-point
 */
export const getMappingValueInvalid = createSelector(
  [getCurrentEntityStore],
  currentEntity => currentEntity.get('mappingValueInvalid') || false
);

export const getDuplicatedDispatchMappings = createSelector(
  [getDispatchMappings,
    getSelectedEntity,
    getCurrentInteractionFieldValue,
    getCurrentChannelTypeValue,
    getCurrentValueFieldValue],
  (dispatchMappingsList,
   selectedEntity,
   currentInteractionFieldValue,
   currentChannelTypeValue,
   currentValueFieldValue) => {
    const dispatchDuplicated = dispatchMappingsList.filter((dispatch) => {
      return (dispatch.get('interactionField') === currentInteractionFieldValue &&
        dispatch.get('channelType') === currentChannelTypeValue &&
        dispatch.get('value') === currentValueFieldValue &&
        dispatch.get('id') !== selectedEntity?.get('id'));
    });

    return dispatchDuplicated?.toJS();
  });
